<template>
  <div class="card-wrapper" v-if="checkPermission(['chartView_tuition_invoice'])">
    <div class="card-top">
      <div class="card-header">
        <div class="card-heading">
          <div class="card-icon">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div>
            <p class="card-title">Phiếu thu học phí</p>
            <p class="card-subtitle">Thống kê theo trạng thái học sinh trong năm {{ currentYear }}</p>
            <div class="header-tags">
              <span class="header-tag">{{ selectedStatusLabel }}</span>
            </div>
          </div>
        </div>
        <div class="card-action">
          <span class="filter-label">Bộ lọc trạng thái</span>
          <el-select
            class="filter-select"
            v-model="kidsStatus"
            placeholder="Trạng thái"
            clearable
            @change="searchByPropertiesFees()"
          >
            <el-option
              v-for="item in this.$funcData.getKidStatusAllList()"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="summary-row" v-if="loaded && summaryCards.length">
        <div
          v-for="summary in summaryCards"
          :key="summary.label"
          class="summary-card"
          :style="{ '--summary-accent': summary.color }"
        >
          <span class="summary-label">{{ summary.label }}</span>
          <strong class="summary-value">{{ summary.value }}</strong>
        </div>
      </div>
    </div>

    <div class="chart-shell">
      <div class="chart-content" v-if="isLoading">
        <div class="state-card state-card--loading">
          <i class="el-icon-loading state-icon"></i>
          <div>
            <p class="state-title">Đang tải dữ liệu biểu đồ</p>
            <span class="state-text">Hệ thống đang tổng hợp thống kê học phí mới nhất.</span>
          </div>
        </div>
      </div>

      <div class="chart-content" v-else-if="loaded && hasData">
        <div class="chartFees" style="margin-top: 102px">
          <div class="chart-caption">
            <span class="chart-caption__dot"></span>
            <span>Biểu đồ cột so sánh theo từng trạng thái học sinh</span>
          </div>
        <ChartBar
          :checkLable="true"
          :chartData="dataConnection.chartData"
          :options="dataConnection.options"
          :height="400"
        ></ChartBar>
        </div>
      </div>

      <div class="chart-content chart-empty" v-else>
        <div class="state-card state-card--empty">
          <i class="el-icon-document-remove state-icon"></i>
          <div>
            <p class="state-title">Chưa có dữ liệu phiếu thu học phí</p>
            <span class="state-text">Hãy thử đổi trạng thái học sinh hoặc kiểm tra lại dữ liệu nguồn.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import moment from "moment";
import ChartStatisticalService from "@/services/ChartStatisticalService";
import ChartBar from "@/views/chartStatistical/chart/ChartBar.vue";

export default {
  components: {ChartBar},
  name: "TuitionBillChart",
  data() {
    return {
      dataConnection: {},
      loaded: false,
      isLoading: false,
      kidsStatus: "",
      dataFeesLabels: [],
      dataFeesList1: [],
      dataFeesList2: [],
      dataFeesList3: [],
      dataSearch: {
        type: "date",
        dateList: [
          moment().subtract(29, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
    }
  },
  computed: {
    currentYear() {
      return moment().get("year");
    },
    hasData() {
      return this.dataFeesLabels.length > 0;
    },
    selectedStatusLabel() {
      if (!this.kidsStatus) {
        return "Tất cả trạng thái";
      }

      const selectedStatus = this.$funcData
        .getKidStatusAllList()
        .find((item) => item.key === this.kidsStatus);
      return selectedStatus ? selectedStatus.value : "Tất cả trạng thái";
    },
    summaryCards() {
      return [
        {
          label: "Đã hoàn thành",
          value: this.getChartTotal(this.dataFeesList1),
          color: "#4f8dfd",
        },
        {
          label: "Chưa hoàn thành",
          value: this.getChartTotal(this.dataFeesList2),
          color: "#ff7a59",
        },
        {
          label: "Chưa có khoản",
          value: this.getChartTotal(this.dataFeesList3),
          color: "#f6b93b",
        },
      ];
    },
  },
  async mounted() {
    await this.searchByPropertiesFees();
  },
  methods: {
    checkPermission,
    getChartTotal(list) {
      return list.reduce((total, item) => total + Number(item || 0), 0);
    },
    createDataset(label, data, color, hoverColor) {
      return {
        label,
        data,
        backgroundColor: color,
        hoverBackgroundColor: hoverColor,
        borderWidth: 0,
        barPercentage: 0.8,
        categoryPercentage: 0.68,
      };
    },
    createBarOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 30,
            right: 12,
            left: 12,
            bottom: 8,
          },
        },
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 9,
            padding: 20,
            fontSize: 12,
            fontColor: "#516074",
          },
        },
        tooltips: {
          mode: "index",
          intersect: false,
          backgroundColor: "rgba(19, 31, 53, 0.92)",
          titleFontSize: 12,
          bodyFontSize: 12,
          xPadding: 12,
          yPadding: 12,
          displayColors: true,
        },
        hover: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          datalabels: {
            color: "#1f2d3d",
            anchor: "end",
            align: "end",
            clamp: false,
            clip: false,
            offset: 6,
            padding: {
              top: 2,
              bottom: 0,
            },
            font: {
              weight: "700",
              size: 12,
            },
            formatter: (value) => {
              return value > 0 ? value : "";
            },
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                fontColor: "#6b7a90",
                fontSize: 12,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              afterDataLimits(scale) {
                const maxValue = Number(scale.max || 0);
                scale.max = maxValue > 0 ? Math.ceil(maxValue * 1.15 + 1) : 5;
              },
              gridLines: {
                color: "rgba(142, 169, 204, 0.18)",
                zeroLineColor: "rgba(142, 169, 204, 0.24)",
                drawBorder: false,
              },
              ticks: {
                beginAtZero: true,
                fontColor: "#7d8ca1",
                fontSize: 12,
                padding: 10,
                precision: 0,
              },
            },
          ],
        },
      };
    },
    fillDataFees() {
      this.dataConnection = {
        chartData: {
          labels: this.dataFeesLabels,
          datasets: [
            this.createDataset("Đã hoàn thành", this.dataFeesList1, "#4f8dfd", "#3273e6"),
            this.createDataset("Chưa hoàn thành", this.dataFeesList2, "#ff7a59", "#ef6340"),
            this.createDataset("Chưa có khoản", this.dataFeesList3, "#f6b93b", "#e5a51b"),
          ],
        },
        options: this.createBarOptions(),
      };
    },
    /**
     * tìm kiếm tất cả khoản của các học sinh
     */
    async searchByPropertiesFees() {
      this.isLoading = true;
      try {
        const resp = await ChartStatisticalService.findFeesKids(
            moment().get("year"),
            this.kidsStatus
        );
        const results = Array.isArray(resp.data.data) ? resp.data.data : [];
        const dataLabels = [];
        const feesYes = [];
        const feesNo = [];
        const feesUn = [];
        for (let i = 0; i < results.length; i++) {
          const e = results[i];
          dataLabels.push(e.name);
          feesYes.push(e.feesYes);
          feesNo.push(e.feesNo);
          feesUn.push(e.feesUn);
        }
        this.dataFeesLabels = dataLabels;
        this.dataFeesList1 = feesYes;
        this.dataFeesList2 = feesNo;
        this.dataFeesList3 = feesUn;
        this.fillDataFees();
        this.loaded = true;
      } catch (e) {
        this.$message({
          message: "Failed to get the data",
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },


  }
}
</script>

<style lang="scss" scoped>
.card-top {
  display: flex;
  flex-direction: column;
}

.chartFees {
  margin-top: 6px;
  height: 100%;
}

.chart-shell {
  position: relative;
  flex: 1;
  min-height: 390px;
  padding: 18px;
  border-radius: 24px;
  background:
    radial-gradient(circle at top right, rgba(100, 152, 255, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid rgba(118, 153, 214, 0.14);
}

.card-wrapper {
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(31, 45, 61, 0.08);
  padding: 20px;
  margin: 20px 0;
  transition: all 0.3s ease;
  height: 100%;
  min-height: 560px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(122, 147, 184, 0.12);
  box-sizing: border-box;
}

.card-wrapper:hover {
  box-shadow: 0 22px 48px rgba(31, 45, 61, 0.12);
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
}

.card-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #ffffff;
  background: linear-gradient(135deg, #4f8dfd, #6d5dfc);
  box-shadow: 0 14px 24px rgba(79, 141, 253, 0.28);
}

.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #22324d;
}

.card-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #7f8da3;
}

.card-action {
  min-width: 170px;
  padding: 14px 16px;
  border-radius: 18px;
  background: rgba(244, 248, 255, 0.95);
  border: 1px solid rgba(118, 153, 214, 0.14);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.filter-label {
  display: inline-block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #72829a;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.filter-select {
  width: 100%;
}

.header-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.header-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #31527f;
  background: rgba(79, 141, 253, 0.12);
}

.header-tag--soft {
  background: rgba(111, 137, 168, 0.12);
  color: #62738c;
}

.summary-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.summary-card {
  position: relative;
  padding: 16px 18px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(118, 153, 214, 0.14);
  box-shadow: 0 10px 24px rgba(31, 45, 61, 0.06);
  overflow: hidden;
}

.summary-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: var(--summary-accent);
}

.summary-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #7d8ca1;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 26px;
  line-height: 1;
  color: #21314c;
}

.chart-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 992px) {
  .card-top {
    min-height: auto;
  }
}

.chart-caption {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: rgba(79, 141, 253, 0.08);
  color: #4f6483;
  font-size: 13px;
  font-weight: 600;
}

.chart-caption__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4f8dfd;
  box-shadow: 0 0 0 4px rgba(79, 141, 253, 0.14);
}

.state-card {
  min-height: 230px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  text-align: left;
}

.state-card--loading {
  background: linear-gradient(135deg, rgba(79, 141, 253, 0.08), rgba(109, 93, 252, 0.08));
}

.state-card--empty {
  background: linear-gradient(135deg, rgba(242, 247, 255, 0.9), rgba(248, 251, 255, 0.95));
}

.state-icon {
  font-size: 36px;
  color: #4f8dfd;
}

.state-title {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 700;
  color: #26344c;
}

.state-text {
  font-size: 13px;
  color: #7d8ca1;
  line-height: 1.6;
}

@media (max-width: 1200px) {
  .card-wrapper {
    min-height: 500px;
    margin: 12px 0;
  }

  .summary-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .card-top {
    min-height: auto;
  }

  .card-header {
    flex-direction: column;
  }

  .card-action {
    width: 100%;
  }

  .chart-shell {
    padding: 14px;
  }

  .state-card {
    flex-direction: column;
    text-align: center;
  }
}
</style>
